module.exports = __webpack_public_path__ + "static/media/lioninthejungle.59d039df.jpg";